import classnames from "classnames";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MultiSelect } from "react-multi-select-component";
import { membersList } from "actions/members";
import UserInfo from "components/UserInfo";
import { TeamMember } from "components/assets/Icons";
import profilePhoto from "assets/images/profile_photo.svg";

import styles from "./TeamMembers.module.scss";

export const TeamMembers = ({
  members = [],
  className,
  selected,
  setSelected,
  employeesPhotos,
  setEmployeesPhotos,
}) => {
  const dispatch = useDispatch();
  const [membersData, setMembersData] = useState([]);

  const data = useSelector((state) => state.members);

  useEffect(() => {
    dispatch(membersList(1, 0));
  }, [dispatch]);

  useEffect(() => {
    data?.list && setMembersData(data?.list);
  }, [data]);

  useEffect(() => {
    membersData &&
      membersData?.map(({ first_name, last_name, photo_url }) => {
        return setEmployeesPhotos(
          employeesPhotos?.set(`${first_name} ${last_name}`, photo_url)
        );
      });
  }, [membersData, employeesPhotos, setEmployeesPhotos]);

  useEffect(() => {
    const list =
      members.length !== 1
        ? members.map((item) => {
            return {
              value: item,
            };
          })
        : [{ value: members[0] }];
    members && setSelected(list);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setSelected]);

  /* For Team Members */
  const teamMembersOptions =
    membersData &&
    membersData?.map(({ first_name, last_name, photo_url, id }) => {
      return {
        label: (
          <UserInfo
            src={photo_url ?? profilePhoto}
            name={first_name + " " + last_name}
          />
        ),
        value: `${first_name} ${last_name}`,
        id: id,
      };
    });

  const teamMembersValueRenderer = (selected) => {
    if (!selected.length) {
      return <TeamMember />;
    }

    if (selected.length > 1) {
      return (
        <>
          <TeamMember /> {`${selected.length} selected`}
        </>
      );
    } else if (selected.length === 1) {
      const element = selected[0].value;
      return (
        <UserInfo
          src={employeesPhotos.get(element)}
          name={element}
          className="photo"
        />
      );
    }
  };

  const teamMembersFilterOptions = (options, filter) => {
    if (!filter) {
      return options;
    }

    return options.filter(({ label }) => {
      return label && label?.props?.name.toLowerCase().includes(filter);
    });
  };

  return (
    <span className={classnames(className, styles.group)}>
      <label htmlFor="teamMembers" className={styles.label}>
        Team Members
      </label>
      <MultiSelect
        className={classnames(
          styles.select
          // formError && selected.length === 0 ? styles.error : ""
        )}
        options={teamMembersOptions}
        value={selected}
        onChange={setSelected}
        valueRenderer={teamMembersValueRenderer}
        filterOptions={teamMembersFilterOptions}
      />
      {/* {formError && selected.length === 0 && (
          <p className={styles.error_message}>{formError}</p>
        )} */}
    </span>
  );
};

export default TeamMembers;
